import * as React from 'react';
import { GroupEventResponse } from '@moovly/clients/lib/resources/bi/bi.interfaces';
import { formatDateLong } from '../../../utils/date';
import { t } from '@moovly/i18n';
import useUser from '../../users/hooks/useUser';
import { ContentLoader } from '@moovly/ui';
import { TableCol, TableRow } from '../../../components/Table';

interface LogsTableRowProps {
  log: GroupEventResponse;
}

const getEventTypeText = (type: string) =>
  t(
    `statistics.events.type.${type
      .toLowerCase()
      .replace(/[-]+/g, ' ')
      .replace(/ (.)/g, function ($1: any) {
        return $1.toUpperCase();
      })
      .replace(/ /g, '')}`
  );
const LogsTableRow: React.FC<LogsTableRowProps> = ({ log }) => {
  const { user, isLoading } = useUser(log.user_id);
  const { user: executor, isLoading: executorLoading } = useUser(log.executor_id);
  const userName = React.useMemo(() => {
    if (isLoading) return <ContentLoader />;
    return `${user?.first_name || ''} ${user?.name || ''}`;
  }, [isLoading, user]);
  const userEmail = React.useMemo(() => {
    if (isLoading) return <ContentLoader />;
    if (!!user) return user.email;
  }, [isLoading, user]);
  const executorName = React.useMemo(() => {
    if (executorLoading) return <ContentLoader />;
    if (!!executor) return executor.email;
  }, [executorLoading, executor]);
  return (
    <TableRow>
      <TableCol>{formatDateLong(log.created_at)}</TableCol>
      <TableCol>{getEventTypeText(log.type)}</TableCol>
      <TableCol>{userName}</TableCol>
      <TableCol>{userEmail}</TableCol>
      <TableCol>{log.payload && log.payload.plan_code}</TableCol>
      <TableCol>{executorName}</TableCol>
    </TableRow>
  );
};

export default LogsTableRow;
